import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';



import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';

/*
  Generated class for the OrcamentoService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ContratosGestaoService {
  urlObterQuestoes: string;
  codigoModuloContratosGestao = 14;
  analiseAtual: any = null;
  idPaginaContratosGestao: string = "966";
  resumoAnalise: any;

  constructor(public http: HttpClient,
    private gestaoPcaService: GestaoPcaService,
    private utilService: UtilService) {
  }

  public obterIdPaginaContratosGestao() {
    return this.idPaginaContratosGestao;
  }

  // public obterListaAnalises(codModulo): Observable<any> {
  //     this.urlObterQuestoes = "analiseOrcamento/?idPca=" + this.gestaoPcaService.getPCA().id;
  //     return this.utilService.getJSON(this.urlObterQuestoes);
  // }

  public obterListaAnalisesJur(codModulo): Observable<any> {
    this.urlObterQuestoes = "contratosGestao?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  // Cadastro dos Contratos de Gestao
  public obterContratosGestaoPorNumero(numero: any): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/listarPorPcaPorContrato?idPca=" + this.gestaoPcaService.getPCA().id + "&nmContrato=" + numero;
    console.log("URL --> " + this.urlObterQuestoes);
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterContratosGestao(): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/listarPorPca?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterContratos(): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/listarContratosPorPca?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public deletarContrato(idContratoGestao) {
    let urlObtencaoDados: string = "contratosGestao/deletar?idContrato=" + idContratoGestao;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public deletarAtoNomeacao(idAtoNomeacao) {
    let urlObtencaoDados: string = "contratosGestao/deletarAtoNomeacao/" + idAtoNomeacao;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public salvarContratosGestao(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/salvar";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarContratosGestao(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/finalizarCadastro?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public getRolResponsaveis(): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/listarPessoasPorPca/" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public importarRolResponsaveis(cdAnalise): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/importarPessoasPorPca?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(this.urlObterQuestoes, null);
  }

  public getGrupos(): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/listarGrupo/";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public getSubGrupos(codGrupo): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/listarSubGrupo/"+codGrupo;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarResponsavel(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/salvarPessoa?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public excluirResponsavel(idPessoaGrupo): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/deletarPessoaGrupo/" + idPessoaGrupo;
    return this.utilService.deleteJSON(this.urlObterQuestoes);
  }

  public finalizarResponsavel(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/finalizarRolResponsaveis?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public listarGrupo(): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/listarGrupo";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public listarSubGrupo(): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/listarSubGrupo";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  //

  // Análises de 3 a 8

  public obterPorNumero(nmContrato): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/obterPorNumero?nmContrato=" + nmContrato + "&idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterAnalise(cdAnalise): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/listarAnalises?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterAnalisePag(pag: any, cdAnalise: any): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/listarAnalisesPag?idPca=" + this.gestaoPcaService.getPCA().id  + "&pag=" + pag + "&cdAnalise=" + cdAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnalise(jsonObjeto, cdAnalise): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/salvarAnalises?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarAnalise(jsonObjeto, cdAnalise): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/finalizarAnalises?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public deletarAnalise(idAnalise, cdAnalise) {
    let urlObtencaoDados: string = "contratosGestao/deletarAnalises?idAnalise=" + idAnalise + "&cdAnalise=" + cdAnalise;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public deletarTodos(cdAnalise): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/deletarTodos?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  /*
  public deletarTodos(cdAnalise): Observable<any> {
    this.urlObterQuestoes = "contratosGestaoExclusao/excluirTodos?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }
  */

  public carregarAnoAnterior(cdAnalise): Observable<any> {
    this.urlObterQuestoes = "contratosGestao/importarAnalises?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  //



  // Analista

  // SEMAFORO

  public obterListaAnalises(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }


  // PREVIEW CERTIFICADO

  public obterPreviewCertificado(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }


  // REGRA 1

  public listarVerificacaoRol(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarVerificacaoRol?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarVerificacaoRol(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarVerificacaoRol?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarVerificacaoRol(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarVerificacaoRol?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public listarTipoResponsaveis(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarTipoResponsaveis";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  // REGRA 2

  public listarAnaliseRelatorioFisico(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarAnaliseRelatorioFisico?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseRelatorioFisico(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarAnaliseRelatorioFisico?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarAnaliseRelatorioFisico(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarAnaliseRelatorioFisico?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // REGRA 3

  public listarServidoresPagamentos(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarServidoresPagamentos?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarServidoresPagamentos(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarServidoresPagamentos?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarServidoresPagamentos(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarServidoresPagamentos?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // REGRA 4

  public listarAnalisePagamentosVsPessoal(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarAnalisePagamentosVsPessoal?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnalisePagamentosVsPessoal(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarAnalisePagamentosVsPessoal?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarAnalisePagamentosVsPessoal(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarAnalisePagamentosVsPessoal?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // REGRA 5

  public listarPagamentosDesacordoCompra(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarPagamentosDesacordoCompra?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarPagamentosDesacordoCompra(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarPagamentosDesacordoCompra?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarPagamentosDesacordoCompra(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarPagamentosDesacordoCompra?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // REGRA 6

  public listarTransferenciaRecursos(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarTransferenciaRecursos?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarTransferenciaRecursos(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarTransferenciaRecursos?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarTransferenciaRecursos(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarTransferenciaRecursos?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // REGRA 7

  public listarAnaliseRelatorioReceitaDespesa(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarAnaliseRelatorioReceitaDespesa?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseRelatorioReceitaDespesa(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarAnaliseRelatorioReceitaDespesa?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarAnaliseRelatorioReceitaDespesa(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarAnaliseRelatorioReceitaDespesa?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }


  // REGRA 8

  public listarParcelasRecebidasVsEmpenho(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarParcelasRecebidasVsEmpenho?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarParcelasRecebidasVsEmpenho(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarParcelasRecebidasVsEmpenho?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarParcelasRecebidasVsEmpenho(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarParcelasRecebidasVsEmpenho?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // REGRA 9

  public listarAnaliseDespesas(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarAnaliseDespesas?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseDespesas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarAnaliseDespesas?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarAnaliseDespesas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarAnaliseDespesas?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // REGRA 10

  public listarRelacaoPessoalCG(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarRelacaoPessoalCG?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarRelacaoPessoalCG(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarRelacaoPessoalCG?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarRelacaoPessoalCG(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarRelacaoPessoalCG?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // REGRA 11

  public listarVerificacaoContratacao(): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/listarVerificacaoContratacao?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarVerificacaoContratacao(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/salvarVerificacaoContratacao?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarVerificacaoContratacao(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContratosGestao/finalizarVerificacaoContratacao?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

}



// WEBPACK FOOTER //
// ./src/providers/contratos-gestao-service.ts